// export const colors = {
//   backgroundPrimary: '#000000',
//   backgroundInverse: '#ffffffff',
//   textMuted: '#efaf10ff',
//   textPrimary: '#f4da17ff',
//   backgroundSubtle: '#cfb578ff',
//   accentPrimary: '#a1a1a1ff',
//   textBody: '#fff',
//   backgroundImage: '#F6F8FB',
//   backgroundElevated: '#1a1919ff',
//   transparent: 'transparent',
// };

export const colors = {
  backgroundPrimary: '#FFFFFF',
  backgroundInverse: '#000000',
  textMuted: '#748BA0',
  textPrimary: '#0C1D2E',
  backgroundSubtle: '#D8E7FF',
  accentPrimary: '#e0c421ff',
  textBody: '#333333',
  backgroundImage: '#F6F8FB',
  backgroundElevated: '#F6F9F9',
  transparent: 'transparent',
};
